import { FormsTable } from 'components';

export default function Invoiced() {
  return <FormsTable persistentListParametersStateKey='invoiced' title='Invoiced' />;
}
